<template>
  <div class="faq">
    <div class="container">
      <section class="section">
        <h3 class="title">樂土Q&A</h3>
        <h6 class="subtitle is-6">搜集網友對於樂土的疑問，一次完全暸解，重點整理大公開</h6>
        <div class="toolbar">
          <button class="button is-primary is-outlined" v-on:click="openAll">展開所有QA</button><button class="button is-info is-outlined" v-on:click="collapseAll">關閉所有QA</button>
        </div>
        <article class="media" v-for="question in questions">
          <figure class="media-left">
            <p class="image icon">
              <i class="fa fa-question-circle" aria-hidden="true"></i>
            </p>
          </figure>
          <div class="media-content ">
            <div class="content question" v-on:click="question.collapsed = !question.collapsed">
              <p>
                  <strong>{{ question.q}}</strong><button class="collapse"><i class="fa" aria-hidden="true" v-bind:class="[question.collapsed ? 'fa-angle-down' : 'fa-angle-up']"></i></button>
              </p>
            </div>
            <article class="media answer" v-show="!question.collapsed">
              <div class="media-content">
                <div class="content">
                  <p>
                    {{ question.a }}
                  </p>
                </div>
              </div>
            </article>
          </div>    
        </article>  
      </section>
    </div>
  </div>
</template>

<script>

export default {
  name: 'faq',
  data: function() {  
    return {
      questions: [
        {q: '什麼是樂土？', a: '樂土是利用水庫淤泥改質後製作成斥水性的微粒子，加入水泥砂漿中，在不影響水泥砂漿原有的透氣性下，以斥水性的物理力讓水滴不能通過而水氣卻可以通過，使水泥砂漿吸水率降低，改善水泥砂漿的體質，讓水泥砂漿防水透氣。', collapsed: true},
        {q: '如何使用樂土於外牆防水工程呢 ？', a: '最簡單的做法即是在外牆抹壁的粗胚1:3砂漿中加入防水粉，即可使建築外牆砂漿具防水透氣性能。', collapsed: true},
        {q: '如何使用樂土防水粉？', a: '只要謹記口訣一包對一包即可，意思是一包50kg的水泥對一包2kg的防水粉，水與砂另外加入，充分攪拌混合即可。禁用噴固精與機仔粉！', collapsed: true},
        {q: '樂土產品到底有哪些？', a: '以樂土為核心原料所衍生出的產品一共有二十幾樣喔，其中最被大家所認識的為「樂土多效能防水粉」與「樂土灰泥」，詳情可以查看我們的樂土產品列表。', collapsed: true},
        {q: '使用防水粉禁止添加噴固精或機仔粉？', a: '是的，因為這兩項常見的水泥砂漿潤滑劑都會使得砂漿的強度下降，蓬鬆率提高，故吸水率也會跟著提高，但樂土本身是降低砂漿吸水率使，這樣等於沒加，另外樂土防水粉本身就有自帶潤滑的效果。', collapsed: true},
        {q: '樂土防水粉有幾種？為什麼會有區別？', a: '樂土防水粉有三種，分別是「抹壁用多效能防水粉 2kg包」「通用型多效能防水粉 2kg包」與「防水土粉 3kg包」，顧名思義抹壁用就是讓施作牆面抹壁時工作性能跟原來師傅施作的習慣一至，通用型一般可以添加於益膠泥 填縫泥 或是地面水泥砂漿在無俗稱土牛的攪拌平台時使用，防水土粉是濕粉，故最常使用的地方就是具備土牛攪拌平台時的地面水泥砂漿使用。', collapsed: true},
        {q: '樂土防水粉是什麼顏色？', a: '正常的樂土防水粉都是水泥本色 灰色的意思，但是如果需要白色的通用防水粉，我們也可以提供。', collapsed: true},
        {q: '樂土仿清水模效果是何種材料？', a: '這是「樂土灰泥」的效果喔，「樂土灰泥」為一種薄層修飾砂漿，施作厚度只有0.3mm-0.5mm，可以很輕易的把不是水泥質感的牆面地面或是木造，轉化成水泥的質感。', collapsed: true},
        {q: '樂土灰泥有幾種顏色？', a: '四種，分別是樂土白 清水灰 樂土灰 水泥水，樂土白不是純白而是帶灰的白色，清水灰為淺偏冷的灰色，樂土灰為帶黃偏暖的略淺水泥灰，水泥灰顧名思義為最接近水泥粉光的灰色', collapsed: true},
        {q: '樂土施工是否需要特殊工班？', a: '不需要，所有的樂土產品都是設計成無特殊做法，不需特殊工班即可施工，只需要合格的手藝與一顆接受樂土的心。', collapsed: true},
        {q: '如何使用樂土灰泥來搭配工業風設計？', a: '樂土灰泥的設計理念是薄層修飾砂漿，可以輕易的將舊的油漆粉刷牆面 板材造型牆面或吧台 甚至非水泥質感之底材，輕易的轉化成水泥的質感，施作厚度只有0.3-0.5mm。', collapsed: true},
        {q: '請問有實體門市嗎？', a: '我們並無實體門市，以網路販售為主，所有樂土產品全省都可以宅配到指定地址。', collapsed: true},    
        {q: '樂土產品最快何時可以送到？', a: '當天下午兩點確認訂單完成匯款手續，最快隔天中午前可以送達。', collapsed: true},            
      ]
    }
  },
  methods: {
    openAll: function() {
        for (var i = 0, j = this.questions.length; i < j; i++) {
          this.questions[i].collapsed = false;
        }
    },
    collapseAll: function() {
        for (var i = 0, j = this.questions.length; i < j; i++) {
          this.questions[i].collapsed = true;
        }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
@import '../mq'

h3 
  color: #666
  font-size: 2rem
h6
  padding-top: 5px
  color: #999
.toolbar
  margin-bottom: 15px
  text-align: right
  button
    font-size: 1rem
    padding: 3px 5px
    height: 2rem
    +mobile
      font-size: 0.8rem
      height: 1.5rem
  button:first-child
    margin-right: 10px

.collapse
  font-size: 1.2rem
  cursor: pointer
  float: right
  border: 1px solid #d5d5d5
.media + .media
  margin-top: 0
.media-left
  margin-right: 0
  .icon 
    width: 36px
    height: 36px
    color: $primary
    i
      font-size: 1.7rem
      margin: 0 auto

.media-content
  cursor: pointer
  p 
    font-size: 1.1rem
    line-height: 1.5
    +mobile
      font-size: 1rem
    strong
      font-size: 1.4rem
      color: #699
      +mobile
        font-size: 1rem

  .answer
    color: #333
    margin-bottom: 1rem


</style>



// WEBPACK FOOTER //
// src/components/Faq.vue